import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../../auth/auth-guard.service';
import { MenuComponent } from './menu.component';
import { MenusComponent } from './menus.component';
import { ListeMenuComponent } from './liste-menu/liste-menu.component';
import { EditMenuComponent } from './edit-menu/edit-menu.component';
import { UpdateMenuComponent } from './update-menu/update-menu.component';

const routes: Routes = [
  {
    path: '',
    component: MenusComponent, canActivate: [AuthGuard],
    data: { permissions: ['adminAccess']},
    children: [

      /* {
        path: 'liste',
        component: MenuComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess', 'adminEditUser']},
      }, */
      {
        path: 'liste',
        component: ListeMenuComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess', 'adminEditMenu']},
      },
      
      {
        path: 'update/:id',
        component: MenuComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess']},
        
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MenusRoutingModule { }

export const routedComponents = [
  MenusComponent,
  MenuComponent,
  ListeMenuComponent
];
